import * as H from "history";
import { Initial, PremiumOffersFilterType } from "redmond";
import { IOfferAvailabilityRequest } from "redmond/hotels-module/interfaces";
import { RequestState, SortOption } from "../reducer";
import {
  FETCH_PREMIUM_OFFERS_SHOP,
  SET_PREMIUM_OFFERS_SHOP_RESULTS,
  SET_OFFERS_SORT,
  SET_IS_USER_TRIGGERED_SEARCH,
  SET_FILTER_CATEGORY_VALUE as SET_SELECTED_FILTER_CATEGORY,
} from "./constants";

export interface IFetchPremiumOffersShop {
  type: FETCH_PREMIUM_OFFERS_SHOP;
  history: H.History;
  params: IOfferAvailabilityRequest;
  isTravelApp?: boolean;
}

export const fetchPremiumOffersShop = (
  history: H.History,
  params: IOfferAvailabilityRequest,
  isTravelApp?: boolean
): IFetchPremiumOffersShop => ({
  type: FETCH_PREMIUM_OFFERS_SHOP,
  history,
  params,
  isTravelApp,
});

export interface ISetPremiumOffersShopResults {
  type: SET_PREMIUM_OFFERS_SHOP_RESULTS;
  payload: RequestState<IOfferAvailabilityRequest, Initial, Error>;
}

export const setPremiumOffersShopResults = (
  payload: RequestState<IOfferAvailabilityRequest, Initial, Error>
): ISetPremiumOffersShopResults => ({
  type: SET_PREMIUM_OFFERS_SHOP_RESULTS,
  payload,
});

export interface ISetOffersSort {
  type: SET_OFFERS_SORT;
  sort: SortOption;
}

export const setOffersSort = (sort: SortOption): ISetOffersSort => ({
  type: SET_OFFERS_SORT,
  sort,
});

export interface ISetIsUserTriggeredSearch {
  type: SET_IS_USER_TRIGGERED_SEARCH;
  isUserTriggeredSearch: boolean;
}

export const setIsUserTriggeredSearch = (
  isUserTriggeredSearch: boolean
): ISetIsUserTriggeredSearch => ({
  type: SET_IS_USER_TRIGGERED_SEARCH,
  isUserTriggeredSearch,
});

export interface ISetSelectedFilterCategory {
  type: typeof SET_SELECTED_FILTER_CATEGORY;
  selectedFilterCategory: PremiumOffersFilterType;
}

export const setSelectedFilterCategory = (
  selectedFilterCategory: PremiumOffersFilterType
): ISetSelectedFilterCategory => ({
  type: SET_SELECTED_FILTER_CATEGORY,
  selectedFilterCategory,
});

export type PremiumCollectionOffersSearchActions =
  | IFetchPremiumOffersShop
  | ISetPremiumOffersShopResults
  | ISetOffersSort
  | ISetIsUserTriggeredSearch
  | ISetSelectedFilterCategory;
